/* @ngInject */
export function MammoQualityControlArtifactEvaluationController($ngRedux, $state, $uiRouterGlobals, $timeout, MammoQualityControlActions) {
    var ctrl = this;
}
